/* RNG Therapy accessibility helpers (WCAG 2.2 AA). Loaded deferred from layout/theme.liquid. */
/* rng-a11y: "home" group — fixes for rng-booster.js (file > 30 KB, not edited directly). Vanilla, defensive, idempotent. */
(function () {
  if (window.__rngA11yHome) return;
  window.__rngA11yHome = true;

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function visible(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }

  /* 1. Newsletter popup (#rng-np, role=dialog aria-modal): keep Tab focus inside while open (2.1.2 / 2.4.3). */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var np = document.getElementById('rng-np');
    if (!np || np.hidden) return;
    var box = np.querySelector('[role="dialog"]') || np;
    var items = Array.prototype.filter.call(box.querySelectorAll(FOCUSABLE), visible);
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1], active = document.activeElement;
    if (!box.contains(active)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  });

  /* 2. "Fresh in the shop" toast: don't auto-hide while hovered or focused (2.2.1); Escape dismisses it. */
  var toastBound = false;
  function bindToast() {
    var t = document.querySelector('.rng-toast');
    if (!t || toastBound) return;
    toastBound = true;
    var dismissed = false, hold = false;
    var keep = function () { return t.matches(':hover') || t.contains(document.activeElement); };
    t.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.rng-toast__x')) dismissed = true; }, true);
    new MutationObserver(function () {
      if (dismissed || hold) return;
      if (!t.classList.contains('is-on') && keep()) { hold = true; t.classList.add('is-on'); hold = false; }
    }).observe(t, { attributes: true, attributeFilter: ['class'] });
    var release = function () { setTimeout(function () { if (!dismissed && !keep()) t.classList.remove('is-on'); }, 2000); };
    t.addEventListener('mouseleave', release);
    t.addEventListener('focusout', release);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !t.classList.contains('is-on')) return;
      var x = t.querySelector('.rng-toast__x');
      if (x) x.click();
    });
  }

  /* 3. Cart upsell + bought-together: no empty links, unambiguous button names (2.4.4 / 4.1.2). */
  function fixLinks() {
    Array.prototype.forEach.call(document.querySelectorAll('.rng-up__item'), function (item) {
      var imgLink = item.querySelector('.rng-up__img');
      if (imgLink && !imgLink.hasAttribute('aria-hidden')) { imgLink.setAttribute('aria-hidden', 'true'); imgLink.setAttribute('tabindex', '-1'); }
      var title = item.querySelector('.rng-up__title');
      var add = item.querySelector('.rng-up__add');
      if (title && add && !add.hasAttribute('aria-label')) {
        var label = (add.textContent || '').replace(/[^A-Za-z0-9 ]/g, '').trim() || 'Add';
        add.setAttribute('aria-label', label + ' ' + title.textContent.trim() + ' to cart');
      }
    });
    Array.prototype.forEach.call(document.querySelectorAll('.rng-fbt'), function (fbt) {
      var names = fbt.querySelectorAll('.rng-fbt__list li .rng-fbt__name');
      Array.prototype.forEach.call(fbt.querySelectorAll('.rng-fbt__imgs a'), function (a, i) {
        var img = a.querySelector('img');
        var hasName = (img && img.getAttribute('alt')) || (a.textContent || '').trim() || a.getAttribute('aria-label');
        if (!hasName && names[i]) a.setAttribute('aria-label', names[i].textContent.replace(/\s+/g, ' ').trim());
      });
    });
  }

  /* 4. Keep focused elements from being hidden behind fixed bottom bars (2.4.11). */
  document.addEventListener('focusin', function (e) {
    var el = e.target;
    if (!el || !el.getBoundingClientRect) return;
    var bars = document.querySelectorAll('.rng-sticky.is-on, .rng-cookie');
    var top = window.innerHeight;
    Array.prototype.forEach.call(bars, function (b) { if (!b.contains(el) && visible(b)) top = Math.min(top, b.getBoundingClientRect().top); });
    if (top >= window.innerHeight) return;
    var r = el.getBoundingClientRect();
    if (r.bottom > top && r.top < window.innerHeight) window.scrollBy(0, r.bottom - top + 16);
  });

  /* 5. Back-to-top hides itself once at the top; move focus to the start of the page so it isn't lost (2.4.3). */
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.rng-top')) return;
    var dest = document.querySelector('.skip-to-content-link') || document.querySelector('header a[href], header button');
    if (dest && dest.focus) { try { dest.focus({ preventScroll: true }); } catch (err) { dest.focus(); } }
  });

  var t;
  function run() { bindToast(); fixLinks(); }
  function boot() {
    run();
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 200); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* a11y (collection group): product card secondary (hover-swap) image is a visual duplicate; hide it from assistive tech. */
(function () {
  function fixCards(root) {
    if (!root || !root.querySelectorAll) return;
    var imgs = root.querySelectorAll('.card__media .media--hover-effect > img + img');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].getAttribute('data-rng-a11y') === '1') continue;
      imgs[i].setAttribute('alt', '');
      imgs[i].setAttribute('data-rng-a11y', '1');
    }
  }
  function run() { fixCards(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('rng:products-loaded', run);
  if ('MutationObserver' in window && document.body) {
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(run, 100);
    }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  }
})();
